import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => {
	return data.data;
};

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	user_id: data.userId,
	report_name: data.report_name,
});
